import { ActionIcon } from "@mantine/core";
import { useWindowScroll } from "@mantine/hooks";
const ScrollToTop = () => {
  const [scroll, scrollTo] = useWindowScroll(); // hook for scroll position

  return (
    <div className="fixed md:bottom-24 bottom-10 right-8 z-50">
      {scroll.y > 450 ? (
        <ActionIcon
          onClick={() => scrollTo({ y: 0 })}
          variant="filled"
          color="orange"
        >
          {/* TODO: put the svg at ista place and import */}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2.5}
            stroke="currentColor"
            className="w-6 h-6"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M4.5 10.5 12 3m0 0 7.5 7.5M12 3v18"
            />
          </svg>
        </ActionIcon>
      ) : null}
    </div>
  );
};

export default ScrollToTop;
